import React from 'react';
import {flattenDeep, flowRight} from 'lodash/fp';

// This function decorates a given component with multiple higher order components.
// The decorations are done in the reversed order of the higher order components arguments.
//
// For example:
//
// export default withHOC(hocOne, hocTwo)(MyComponent);
//
// ... is the same as:
//
// export default hocOne(hocTwo(MyComponent));
export const withHOC =
  (...higherOrderComponents: any[]) =>
  (Component: any) =>
    flowRight(flattenDeep(higherOrderComponents))(Component);

// This function converts a stateless-functional component to a class component.
//
// This function is mainly used in the implementation of other foundational higher
// order functions in the app (`withTranslation`, `withTheme`, etc.). The reason for
// that is so that those foundational higher order functions can be both easily written
// and work with ReactNative's hot-module-reloading feature (which has trouble
// hot-swapping stateless-functional components).
//
// Having stateless-functional components in the app is NOT a problem, nor is it
// necessarily a problem for them to not be hot-swappable. However when a higher order
// component is really high up in the component tree, and when some code under it
// changes, that higher order component being not hot-swappable causes the app to reload
// and lost navigation state which in turn causes the app to navigate back to a default
// state/screen after reload, and that is very annoying during development. That's why
// those higher order components in the app are made using this function to ensure that
// they actually exist as class components and thus would work well with ReactNative's
// hot-module-reloading feature.
export const asClassComponent = (renderFn: any) =>
  class extends React.PureComponent {
    // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
    render() {
      return renderFn(this.props);
    }
  };
